// action types
export const SET_ACTIONS = "setActions";
export const ADD_ACTIONS = "addActions";
export const REMOVE_ACTIONS = "removeActions";

// mutation types
export const SET_BUTTON_ACTIONS = "setButtonActions";
export const SET_LINK_ACTIONS = "setLinkActions";
export const APPEND_BUTTON_ACTIONS = "appendButtonActions";
export const APPEND_LINK_ACTIONS = "appendLinkActions";
export const REMOVE_BUTTON_ACTIONS = "removeButtonActions";
export const REMOVE_LINK_ACTIONS = "removeLinkActions";
export const SHOW_ACTIONS_BAR = "showActionsBar";
export const SHOW_MOBILE_TOGGLE = "showMobileToggle";

export default {
  state: {
    action: {
      buttons: [],
      links: []
    },
    showActionBar: true,
    showMobileToggle: false
  },
  getters: {
    buttonActions(state) {
      return state.action.buttons;
    },
    linkActions(state) {
      return state.action.links;
    },
    showActionBar(state) {
      return state.showActionBar;
    },
    showMobileToggle(state) {
      return state.showMobileToggle;
    }
  },
  actions: {
    [SET_ACTIONS](state, payload) {
      state.commit(SET_BUTTON_ACTIONS, payload.buttons);
      state.commit(SET_LINK_ACTIONS, payload.links);
    },
    [ADD_ACTIONS](state, payload) {
      if (typeof payload.buttons === "object") {
        payload.buttons.forEach(item =>
          state.commit(APPEND_BUTTON_ACTIONS, item)
        );
      }

      if (typeof payload.links === "object") {
        payload.links.forEach(item => state.commit(APPEND_LINK_ACTIONS, item));
      }
    },
    [REMOVE_ACTIONS](state, payload) {
      if (typeof payload.buttons === "object") {
        payload.buttons.forEach(item =>
          state.commit(REMOVE_BUTTON_ACTIONS, item)
        );
      }

      if (typeof payload.links === "object") {
        payload.links.forEach(item => state.commit(REMOVE_LINK_ACTIONS, item));
      }
    }
  },
  mutations: {
    [SET_BUTTON_ACTIONS](state, payload) {
      state.action.buttons = payload ?? [];
    },
    [SET_LINK_ACTIONS](state, payload) {
      state.action.links = payload ?? [];
    },
    [APPEND_BUTTON_ACTIONS](state, payload) {
      if (
        state.action.buttons.findIndex(x => x.event === payload.event) === -1
      ) {
        state.action.buttons = [...state.action.buttons, payload];
      }
    },
    [APPEND_LINK_ACTIONS](state, payload) {
      if (state.action.links.findIndex(x => x.to === payload.to) === -1) {
        state.action.links = [...state.action.links, payload];
      }
    },
    [REMOVE_BUTTON_ACTIONS](state, payload) {
      let index = state.action.buttons.findIndex(
        x => x.event === payload.event
      );
      if (index !== -1) {
        state.action.buttons.splice(index, 1);
      }
    },
    [REMOVE_LINK_ACTIONS](state, payload) {
      let index = state.action.links.findIndex(x => x.to === payload.to);
      if (index !== -1) {
        state.action.links.splice(index, 1);
      }
    },
    [SHOW_ACTIONS_BAR](state, bool) {
      state.showActionBar = bool;
    },
    [SHOW_MOBILE_TOGGLE](state, bool) {
      state.showMobileToggle = bool;
    }
  }
};
